import React from 'react';
import "../../node_modules/react-vis/dist/style.css";
import {
  XYPlot,
  XAxis,
  YAxis,
  makeVisFlexible,
  VerticalGridLines,
  HorizontalGridLines,
  VerticalBarSeries,
  DiscreteColorLegend
} from "react-vis";

const StackedBar = (props) => {
  const BarSeries = VerticalBarSeries;
  const FlexibleXYPlot = makeVisFlexible(XYPlot);
  const {data, ticks, lookup} = props;

  const legends = [];
  
  const myPalette = {
    1: '#164B48',
    2: '#246F5D',
    3: '#459369',
    4: '#76B76E',
    5: '#B2D96F',
    6: '#F9F871',
    7: '#FFE583'
  }

  data.map((data, i) => {
    legends.push({title: data.name, color: myPalette[i]});
  });

  return (
    <FlexibleXYPlot
    xType="ordinal"
    margin={{ left: 60 }}
    xDistance={100}
    stackBy="y"
    >
    <DiscreteColorLegend height={220} width={300} items={legends} />
      <VerticalGridLines />
      <HorizontalGridLines />
      <XAxis tickFormat={(v) => `${lookup[v]}`} tickValues={ticks} />
      <YAxis tickFormat={props.format}/>
      {data.map((data, i) => {
        console.log(data);
        return <BarSeries data={data.data} color={myPalette[i]} />;
      })}
    </FlexibleXYPlot>
  );
};

export default StackedBar